import React, { useEffect, useState } from 'react';
import { Spinner, Table } from 'react-bootstrap';
import { getUserStakePayoutData } from '../../../core/services/all.api';
import { formatDateV2 } from '../../../core/helper/date-format';
const Payout = () => {
    const [getUserStake, setGetUserStake] = useState(null);
    const [loading, setLoading] = useState(true);
    const getData = async () => {
        setLoading(() => true)
        const stakeData = await getUserStakePayoutData()
        // console.log(stakeData)
        if (stakeData.status && (stakeData.data).length > 0) {
            setGetUserStake(() => stakeData.data)
        }
        else {
            setGetUserStake(() => null)
        }
        setLoading(() => false)
    }
    useEffect(() => {
        getData();
    }, [])
    return (
        <div className='px-3 my-3'>
            <div>
                <h1 style={{ fontSize: '1.5rem' }}><strong>Payout</strong></h1>
            </div>
            <div className='mt-3' style={{ maxHeight: 'calc(96vh - 150px)', overflow: 'auto' }}>
                <Table responsive bordered hover variant="dark" className="custom-table-payout"
                    style={{ backgroundColor: 'transparent' }}
                >
                    <thead>
                        <tr>
                            <th className='bg-transparent'>Date</th>
                            <th className='bg-transparent'>ID</th>
                            <th className='bg-transparent'>PARENT ID</th>
                            <th className='bg-transparent'>LEVEL (%)</th>
                            <th className='bg-transparent'>Commission ($)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            (loading && !getUserStake) &&
                            <tr>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}><Spinner aria-label="Center-aligned spinner example" size={'md'} /></td>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                                <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            </tr>
                        }
                        {(getUserStake && getUserStake.length > 0 && !loading) ? getUserStake.map((el, index) => {
                            return (
                                <tr key={index}>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{formatDateV2(el?.createdAt || 0)}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{(el?.referredId?._id).slice(14)}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px', wordBreak: 'break-all' }}>{el?.userId.slice(14)}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}>{(el?.commissionRate) || 0}</td>
                                    <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}>{(el?.commission) || 0}</td>
                                </tr>)
                        }

                        ) : <tr>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}>No Data!</td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                            <td className='font-pop bg-transparent py-3' style={{ fontSize: '14px' }}></td>
                        </tr>}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default Payout;